module.exports = __webpack_public_path__ + "media/images/turbochargers/01-31e96696f6ead9e48ae3d46c60cc3cef.png";